const BEM_FIELDS = {
    ID: 'id',
    ID_BEM: 'idBem',
    NOME: 'nomeBem',
    NOME_TIPO_BEM: 'nomeTipoBem',
    ID_TIPO_BEM: 'idTipoBem',
    QUANTIDADE: 'quantidade',
    CONTEUDOS: 'conteudos',
    IN_GARANTIA: 'inGarantia',
    QUESTIONARIOS: 'questionarios',
    VALOR_UNITARIO: 'valorUnitario',
    ID_TIPO_CONSTRUCAO: 'idTipoConstrucao',
    FRANQUIA_PERSONALIZADO: 'franquiaPersonalizado',
    VALOR_LMI: 'valorLmi',
    PERC_AGRAVO: 'percentualAgravo',
    PERC_DESCONTO: 'percentualDesconto',

    COBERTURAS_OBRIGATORIAS: 'coberturasObrigatorias',
    COBERTURAS_NAO_OBRIGATORIAS: 'coberturasNaoObrigatorias',
    COBERTURAS_PERSONALIZADO: 'coberturasPersonalizado'
};

export default BEM_FIELDS;
